<template>
  <div class="manageusers">
    <vk-modal :show.sync="showPassword">
      <vk-modal-title>Nuova password</vk-modal-title>
      <p>
        E' stata assegnata una password generata casualmente all'utente <b>{{ changedPasswordUserEmail }}</b>, è stata inviata via email all'utente stesso ma è comunque possibile copiarla ed inviarla manualmente se necessario.
      </p>
      <p>
        <b>NOTA:</b> 
        La password non potrà mai più essere vista, questa è l'unica occasione di copiarla. Se la password viene persa è necessario resettarla (sempre dalla gestione utenti)
      </p>
      <p>
        <span class="password">
          {{ changedPassword }}
        </span>
      </p>
      <p class="uk-text-right">
        <vk-button @click="showPassword = false">Chiudi</vk-button>
      </p>
    </vk-modal>
    <vk-modal :show.sync="confirmDelete">
      <vk-modal-title>Eliminazione utente</vk-modal-title>
      <p>
        <b>ATTENZIONE</b>
        L'utente <b>{{ removingUserEmail }}</b> sta per essere eliminato, non potrà più accedere alla piattaforma.
        I dati raccolti dai dispositivi ad esso associati <i>non</i> verranno eliminati, bensì rimarranno nel database e saranno visibili ad un futuro utente al quale verrà associato lo stesso (o gli stessi) dispositivi.
        Se un utente dovesse quindi venire eliminato per errore, è possibile ricrearlo e riassociare gli stessi dispositivi per ripristinare la situazione precedente.
      </p>
      <p>
        In ogni caso, assicurarsi di voler effettivamente portare a termine questa operazione
      </p>
      <p class="uk-text-right">
        <vk-button @click="doDelete">Elimina</vk-button>
        <vk-button @click="confirmDelete = false" type="primary">Annulla</vk-button>
      </p>
    </vk-modal>
    <vk-modal :show.sync="confirmReset">
      <vk-modal-title>Reset password utente</vk-modal-title>
      <p>
        <b>ATTENZIONE</b>
        La password dell'utente <b>{{ resettingUserEmail }}</b> sta per essere resettata. Verrà generata una nuova password e non sarà più possibile per esso accedere con la password vecchia.
        La password generata verrà inviata per email all'utente e mostrata <b>una sola volta</b> a schermo subito dopo il reset. Si è sicuri di voler procedere?
      </p>
      <p class="uk-text-right">
        <vk-button @click="doReset">Reset password</vk-button>
        <vk-button @click="confirmReset = false" type="primary">Annulla</vk-button>
      </p>
    </vk-modal>
    <vk-card>
      <h1>Gestione utenti</h1>
      Creazione, eliminazione e reset password di utenti

      <vk-table :data="users" striped hoverable>
        <vk-table-column title="Email" cell="email"></vk-table-column>
        <vk-table-column headless cell="email">
          <div slot-scope="{ cell }">
            <vk-button type="secondary" size="small" @click="() => { resetPassword(cell) }">Reset PW</vk-button>
            <vk-button type="danger" size="small" @click="() => { deleteUser(cell) }">Elimina</vk-button>
          </div>
        </vk-table-column>
      </vk-table>

      <h3>Nuovo utente</h3>
      <p>
        Inserire un indirizzo email valido e cliccare "Crea utente" per creare un nuovo utente.<br>
        La password verrà generata casualmente e inviata per email all'indirizzo specificato (che verrà usato per effettuare il login).<br>
      </p>
      <p>
        La password generata verrà inoltre mostrata dopo la creazione (<b>attenzione:</b> non potrà mai più essere vista) nel caso si volesse comunicarla tramite altri mezzi.<br>
        Se la password viene persa è possibile usare la funzione "Reset PW" nella lista degli utenti qui sopra per rigenerare una password casuale che verrà re-inviata e rimostrata a schermo (sempre una volta sola).
      </p>
      <form>
        <div class="uk-margin">
          <input class="uk-input uk-form-width-large" v-model.trim="newUserEmail" type="text" placeholder="Indirizzo email valido">
        </div>
        <vk-button type="primary" @click="createUser">Crea utente</vk-button>
      </form>
    </vk-card>
  </div>
</template>

<style lang="scss">
  .password {
    font-family: monospace;
    font-size: 2em;
    font-weight: bold;
    font-stretch: expanded;
  }
</style>

<script>
import config from '@/config'

export default {
  name: 'manageusers',

  components: {},

  data () {
    return {
      users: [],
      newUserEmail: "",
      
      showPassword: false,
      changedPasswordUserEmail: "",
      changedPassword: "",

      confirmDelete: false,
      removingUserEmail: "",

      confirmReset: false,
      resettingUserEmail: ""
    }
  },

  created () {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
      return
    }

    if (!this.$store.state.isAdmin) {
      this.$router.push('/')
      return
    }

    this.updateList()
  },

  methods: {
    updateList () {
      this.$http.get(config.API_URL + '/allUsers', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(
        (response) => {
          if (response.body == null) {
            this.users = []
          } else {
            this.users = response.body.filter((user) => { return user.isAdmin == false }).map((user) => { return {email: user.email} })
          }
        }, (err) => {
          console.log(err)
          this.$store.commit('LOGOUT_USER')
          localStorage.removeItem('token')
          this.$router.push('/login')
        }
      )
    },

    deleteUser (email) {
      this.removingUserEmail = email
      this.confirmDelete = true
    },

    doDelete () {
      let formData = new FormData()
      formData.append("email", this.removingUserEmail)

      this.$http.post(config.API_URL + '/deleteUser', formData, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(
        () => {
          this.updateList()
          this.removingUserEmail = ""
          this.confirmDelete = false
        }, (err) => {
          console.log(err)
          this.removingUserEmail = ""
          this.confirmDelete = false
        }
      )
    },

    resetPassword (email) {
      this.resettingUserEmail = email
      this.confirmReset = true
    },

    doReset () {
      let email = this.resettingUserEmail
      
      let formData = new FormData()
      formData.append("email", email)

      this.$http.post(config.API_URL + '/resetUserPassword', formData, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(
        (response) => {
          this.changedPasswordUserEmail = email
          this.changedPassword = response.body
          this.showPassword = true

          this.resettingUserEmail = ""
          this.confirmReset = false
        }, (err) => {
          console.log(err)
          this.resettingUserEmail = ""
          this.confirmReset = false
        }
      )
    },

    createUser () {
      if (this.newUserEmail == "") {
        return
      }

      let email = this.newUserEmail

      let formData = new FormData()
      formData.append("email", email)

      this.$http.post(config.API_URL + '/addUser', formData, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(
        (response) => {
          this.changedPasswordUserEmail = email
          this.changedPassword = response.body
          this.showPassword = true

          this.updateList()
          this.newUserEmail = ""
        }, (err) => {
          console.log(err)
          this.$store.commit('LOGOUT_USER')
          localStorage.removeItem('token')
          this.$router.push('/login')
        }
      )
    }
  }
}
</script>
